// frontend/src/constants/visualization.ts
// Constants for 3D visualization and lashing calculations

// Axis and scaling constants
export const AXIS_LENGTH_MULTIPLIER = 0.65;
export const DEFAULT_LASHING_HEIGHT_RATIO = 0.5;
export const LASHING_HEIGHT_RATIO_WITH_COG = 0.75;
export const LASHING_HEIGHT_CAP_RATIO = 0.9;

// Angle constants (in degrees)
export const MIN_LASHING_ANGLE_DEGREES = 30;
export const MAX_LASHING_ANGLE_DEGREES = 45;
export const DEFAULT_LASHING_ANGLE_DEGREES = 45;

// Height transition ranges for angle calculation
export const MIN_HEIGHT_FOR_ANGLE_TRANSITION = 0.2;
export const MAX_HEIGHT_FOR_ANGLE_TRANSITION = 1.0;

// Attachment and positioning constants
export const LASHING_ATTACH_INSET = 0.2; // 20cm from corner
export const MIN_ATTACHMENT_HEIGHT_FROM_FLOOR = 0.2; // 20cm
export const COG_HEIGHT_OFFSET_BELOW = 0.1; // 10cm below CoG

// Support block scaling
export const SUPPORT_BLOCK_AVG_DIM_SCALING = 2.8;
export const SUPPORT_BLOCK_MIN_SCALE = 0.7;
export const SUPPORT_BLOCK_MAX_SCALE = 1.8;

// CoG risk thresholds
export const COG_LOW_RISK_THRESHOLD = 0.3;
export const COG_HIGH_RISK_THRESHOLD = 0.6;

// Loop lashing positioning
export const LOOP_LASHING_PAIR_SPACING_RATIO = 0.15; // 15% of cargo width
export const LOOP_LASHING_COUPLE_GAP = 0.15; // Gap between ropes in a couple

// Camera and lighting defaults
export const DEFAULT_CAMERA_POSITION: [number, number, number] = [7, 4.6, 8];
export const DEFAULT_CAMERA_FOV = 40;

// Grid settings
export const GRID_SIZE = 20;
export const GRID_DIVISIONS = 20;

// Floor grid position offset
export const FLOOR_GRID_Y_OFFSET = -0.01;

// CoG sphere properties
export const COG_SPHERE_RADIUS = 0.11;
export const COG_SPHERE_EMISSIVE_INTENSITY = 1.0;

// Label positioning
export const AXIS_LABEL_SCALE_DEFAULT = 1.4;
export const AXIS_LABEL_SCALE_SMALL = 1.1;
export const COG_LABEL_Y_OFFSET = 0.3;

// Lighting intensities
export const AMBIENT_LIGHT_INTENSITY_DARK = 0.45;
export const AMBIENT_LIGHT_INTENSITY_LIGHT = 0.8;
export const DIRECTIONAL_LIGHT_INTENSITY_DARK = 0.75;
export const DIRECTIONAL_LIGHT_INTENSITY_LIGHT = 1.1;

// Direction vectors for lashing calculations
export const LASHING_DIRECTIONS = {
  forward: 'forward',
  backward: 'backward',
  right: 'right',
  left: 'left'
} as const;

// Color schemes
export const AXIS_COLORS = {
  x: { dark: '#f97316', light: '#ea580c' }, // Orange
  z: { dark: '#60a5fa', light: '#1d4ed8' }  // Blue
};

// Risk-based CoG colors
export const COG_COLORS = {
  default: '#16a34a', // Green
  medium: '#f97316', // Orange
  high: '#ff1f1f'    // Red
};